import React from "react";
import { withRouter } from "next/router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LeadCTASection from "components/LeadCTASection";
import Footer from "components/Footer";
import PATHS from "utils/paths";
import { getAppUserCapabilities } from "utils/mapStateToProps";
import { capabilityFlags } from "utils/capability";
import { landingStyles } from "components/Landing/landingStyles";
import ShortLinkPreviewSection from "components/Landing/ShortLinkPreviewSection";
import Citations from "components/Citations";
import SlimCTA from "components/SlimCTA";
import HeroBanner from "components/Marketing/Components/HeroBanner";
import { ENV } from "utils/constants/env";
import { ApplicationContextProvider } from "utils/context";
import StripeRestricted from "components/Disclaimers/StripeRestricted";
import RecaptchaNotice from "components/RecaptchaNotice";
import { fetchAppBuilder, fetchAppCheckout } from "actions/app";
import { fetchMockUserDetails, fetchUserDetails } from "actions/auth";
import { fetchMerchantAccountTaxRates } from "actions/taxRate";
import { fetchMerchantAccountShippingRates } from "actions/shippingRate";
import {
  fetchMerchantAccountProductsPrices,
  fetchMerchantAccountCouponsPromotionCodes
} from "actions/merchantAccount";
import { ensureUnauthInit } from "utils/hooks/unauth";

const MarketingCheckout = ({ shortLink, actions }) => {
  const { loading, application, merchantAccount } = ensureUnauthInit({
    fetchMerchantAccountProductsPrices:
      actions.fetchMerchantAccountProductsPrices,
    fetchMerchantAccountCouponsPromotionCodes:
      actions.fetchMerchantAccountCouponsPromotionCodes,
    fetchMerchantAccountTaxRates: actions.fetchMerchantAccountTaxRates,
    fetchMerchantAccountShippingRates:
      actions.fetchMerchantAccountShippingRates,
    fetchAppCheckout: actions.fetchAppCheckout,
    fetchAppBuilder: actions.fetchAppBuilder,
    fetchUserDetails: actions.fetchUserDetails,
    fetchMockUserDetails: actions.fetchMockUserDetails
  });

  const signupCTA = (
    <div className="pt3 mw8 center">
      <LeadCTASection
        header="Ready to create your own payment links?"
        subheader="Sign up to get started."
        action={{ href: PATHS.SIGNUP, copy: "Sign up" }}
      />
    </div>
  );

  const tryCTA = (
    <SlimCTA
      header="Ready to build a payment link?"
      subheader="Try our link builder to see how easy it is to create a payment link."
      actions={[
        {
          tag: "link",
          copy: "Build a payment link",
          href: PATHS.FEATURES_LINKS_BUILDER
        }
      ]}
    />
  );

  const heroProps = {
    subheader: "Sell from anywhere with payment links.",
    header: [
      {
        copy: "The"
      },
      {
        copy: "one click",
        classes: "color-primary underline"
      },
      {
        copy: "way for your customers to checkout."
      }
    ]
  };

  return (
    <ApplicationContextProvider
      application={application}
      merchantAccount={merchantAccount}
      env={ENV.TEST}
    >
      <div className="w-100 relative">
        <div className="mw8 center">
          <HeroBanner {...heroProps} />
          {shortLink && (
            <ShortLinkPreviewSection shortLink={shortLink} loading={loading} />
          )}
          <div className="ph3 pt3">
            <StripeRestricted />
          </div>
          <div className="pt4 ph3">{tryCTA}</div>
        </div>
        {signupCTA}
        {/* <!-- Footer  --> */}
        <div className="mw8 center ">
          <div className="pt3">
            <RecaptchaNotice />
          </div>
          <div className="pv3 ph3 ph0-l">
            <Citations />
          </div>
          <div className="pt5 hairline-1 bt">
            <Footer />
          </div>
        </div>
        <style jsx>{landingStyles}</style>
      </div>
    </ApplicationContextProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    flags: capabilityFlags(getAppUserCapabilities(state))
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchAppBuilder,
      fetchAppCheckout,
      fetchUserDetails,
      fetchMockUserDetails,
      fetchMerchantAccountProductsPrices,
      fetchMerchantAccountCouponsPromotionCodes,
      fetchMerchantAccountTaxRates,
      fetchMerchantAccountShippingRates
    },
    dispatch
  )
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MarketingCheckout)
);
